var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 484 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.414,11.766l182,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.414,11.766l182,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.282,4.824c0.025,-0.063 0.022,-0.147 0.075,-0.19c0.182,-0.147 2.202,-0.898 2.396,-0.97c11.836,-4.403 17.256,-0.481 17.946,-0.111c4.337,2.321 4.61,6.721 4.654,7.421c0.531,8.551 -6.84,13.203 -20.853,11.413c-1.138,-0.145 -13.774,-1.455 -32.808,-8.969c-8.088,-3.193 -19.576,-9.663 -32.068,-10.103c-8.285,-0.292 -17.604,-0.932 -17.99,8.359c-0.234,5.652 5.7,7.858 8.595,8.189c7.188,0.823 12.961,-2.214 13.126,-2.228c0.148,-0.013 0.32,0.116 0.119,0.263c-0.002,0.001 -1.033,0.476 -2.233,0.9c-6.486,2.289 -11.383,1.369 -12.822,1.149c-2.168,-0.33 -8.711,-1.788 -8.851,-8.946c-0.209,-10.76 10.741,-10.962 14.981,-10.994c1.114,-0.008 5.237,0.064 7.418,0.255c12.645,1.101 22.887,7.176 33.039,11.008c0.392,0.148 16.289,6.463 30.716,8.046c19.792,2.172 17.958,-9.631 17.568,-11.177c-0.162,-0.642 -0.986,-3.44 -3.921,-4.89c-7.649,-3.779 -18.863,1.663 -18.897,1.649c-0.063,-0.024 -0.215,-0.011 -0.19,-0.074Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.228,11.128c1.502,-1.09 7.777,-5.839 13.539,-5.46c-2.258,0.579 -4.205,1.439 -10.104,6.527c-1.856,1.602 -1.884,1.583 -4.105,2.615c-5.164,2.4 -8.758,3.866 -12.758,4.104c5.26,-1.856 8.376,-5.187 13.428,-7.786Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.228,11.128c1.502,-1.09 7.777,-5.839 13.539,-5.46c-2.258,0.579 -4.205,1.439 -10.104,6.527c-1.856,1.602 -1.884,1.583 -4.105,2.615c-5.164,2.4 -8.758,3.866 -12.758,4.104c5.26,-1.856 8.376,-5.187 13.428,-7.786Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBreak);
export default __webpack_public_path__ + "static/media/lineBreak.690b2550da730c08ad9f59c44a89e6ff.svg";
export { ForwardRef as ReactComponent };